import { useCustomerLoaders, useCustomerTypeLoaders, useHoardHooks, useHoardLoaders, writePriceListExcel } from '../../../modules/sales'
import { useCategoryLoaders, useProductLoaders } from '../../../modules/products'
import { useSystemActions } from '../../../modules/system'

// Lista de precios congelada del acopio, con el mismo formato que la descarga de una lista de precios
export const useDownloadHoardPricesListCSV = () => {
    const { pricesListFileName } = useHoardHooks()

    const hoardLoaders = useHoardLoaders()
    const productLoaders = useProductLoaders()
    const categoryLoaders = useCategoryLoaders()
    const customerLoaders = useCustomerLoaders()
    const customerTypeLoaders = useCustomerTypeLoaders()
    const systemActions = useSystemActions()

    return async (hoardId: string) => {
        const hoard = (await hoardLoaders().loadHoard(hoardId))!

        const [products, categories, customer, customerType, company] = await Promise.all([
            productLoaders().loadProducts(Object.keys(hoard.pricesList)),
            categoryLoaders().loadAllCategories(),
            customerLoaders().loadCustomer(hoard.customerId),
            customerTypeLoaders().loadCustomerType(hoard.customerTypeId),
            systemActions(hoard.companyId).fetchCompanyById(hoard.companyId)
        ])

        const archivedCategoryIds = categories.filter(category => category.archived).map(category => category.id)

        // Los productos eliminados (no encontrados), archivados o de categorías archivadas no se incluyen
        const rows = Object.entries(hoard.pricesList)
            .map(([productId, price]) => ({ product: products.find(product => product.id === productId), price }))
            .filter(({ product }) => !!product && !product.archived && !archivedCategoryIds.includes(product.categoryId))
            .map(({ product, price }) => ({
                categoryName: categories.find(category => category.id === product!.categoryId)?.name || 'Sin Categoría',
                supplierCode: product!.supplierCode,
                name: product!.name,
                price
            }))

        writePriceListExcel({
            headerRows: [
                [company?.name || 'Empresa'],
                ['Lista de Precios', customerType?.name || ''],
                ['Acopio', `#${hoard.code}`],
                ['Cliente', customer?.name || ''],
                ['Fecha', new Date().toLocaleDateString()]
            ],
            rows,
            fileName: `${pricesListFileName(hoard)}.xlsx`,
            showSupplierCode: true
        })
    }
}
